module.exports = __webpack_public_path__ + "img/red_065.20a8bbac.png";